import React from 'react';
import { ComponentInfo, ChangeEmail as ChangeEmailComponent } from '@components';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';

export const ChangeEmailPlaceholder: React.FC = () => {
	return (
		<ComponentInfo name="ChangeEmailPlaceholder">
			<Box
				styles={{
					flexDirection: 'column',
					marginTop: rem(16),
				}}
			>
				<ChangeEmailComponent />
			</Box>
		</ComponentInfo>
	);
};
